import React, { useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import { UPDATE_PHONE_NUMBER } from "utils";
import { ERROR_STATUS } from "utils/constants";
import UpdateUserDetailsModal from "./UpdateUserDetailsModal";

const UpdatePhoneModal = ({ user, setNewNum, setPhoneUpdated, refetch }) => {
  const [number, setNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [updatePhone] = useMutation(UPDATE_PHONE_NUMBER);

  const handleSubmit = async phone_number => {
    if (
      phone_number.length !== 12 ||
      phone_number[0] !== "+" ||
      phone_number[1] !== "1"
    ) {
      setErrorMessage('Please use the desired format "+19009119000"');
      return;
    }

    setLoading(true);
    const res = await updatePhone({
      variables: {
        email: user.email,
        phone_number
      }
    });

    const {
      data: {
        updatePhoneNumber: { status, message }
      }
    } = res;
    if (status === ERROR_STATUS) {
      if (message === "[udpatePhoneNumber]: phone number is already in use.") {
        setErrorMessage(
          "The desired phone number is already being used by another user."
        );
        setLoading(false);
        return;
      }
      setErrorMessage(
        "There was an error updating the phone number. Please try again in 5 minutes.  If this persists, please reach out to dev-support."
      );
      setLoading(false);
      return;
    }
    setLoading(false);
    setSuccess(true);
    setPhoneUpdated(true);
    setNewNum(phone_number);
    refetch();
  };

  return (
    <UpdateUserDetailsModal
      label="Phone Number"
      currentValue={user.phone_number}
      onSubmit={() => handleSubmit(number)}
      updateNewValue={setNumber}
      errorMessage={errorMessage}
      loading={loading}
      successMainMessage="Phone number has been updated to:"
      successSubMessage={`${number}`}
      showSuccessState={success}
    />
  );
};

export default UpdatePhoneModal;